import { render, staticRenderFns } from "./SalesInvestChart.vue?vue&type=template&id=64c5e9be&scoped=true&"
import script from "./SalesInvestChart.vue?vue&type=script&lang=js&"
export * from "./SalesInvestChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvestChart.vue?vue&type=style&index=0&id=64c5e9be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5e9be",
  null
  
)

export default component.exports